import { Injectable } from '@angular/core';
import { BaseService } from '../../abstract/base.service';
import { DroneManufacturer } from '../data-models/drone-manufacturer.model';

/**
 * Drone manufacturer lookups for dropdowns: `GET /lookups/drone-manufacturers` (hub `user-lookups-controller.ts`).
 * Read-only for web users; use the inherited `getMany()`.
 */
@Injectable({
  providedIn: 'root'
})
export class DroneManufacturerService extends BaseService<DroneManufacturer> {
  constructor() {
    super('lookups/drone-manufacturers', DroneManufacturer);
  }
}
